/**
 * as of Nov 1, 2022 sprockets is not configured to support typescript
 * so the interface definitions are just here as comments
 * so that we can see the shape of the data we want to track
 */
import { analyticsTrack } from './analytics_util';

// interface EventProperties {
//   article_id?: number;
//   awareness_bar_text?: string;
//   can_read_content?: boolean;
//   identifier?: number;
//   location?: string;
//   name?: string;
//   page?: string;
//   type?: string;
// }

/**
 *
 * @param {string} generalEventName can be used as a custom name
 *  or either 'Views' or 'Clicks' for Segment
 * @param {string} ahoyEventName custom event name specifically for ahoy
 * @param {EventProperties} properties properties to be passed to ahoy and segment
 */
const trackEvent = (generalEventName, ahoyEventName = null, properties = {}) => {
  if (currentUser) {
    addCurrentUserToProperties(properties, currentUser);
  }
  if (currentPage?.articleId) {
    properties.article_id = currentPage.articleId;
  }
  ahoy.start();
  ahoy.track(ahoyEventName || generalEventName, properties);
  analyticsTrack(generalEventName, properties);
};

export const trackAhoyEventOnly = (ahoyEventName = null, properties = {}) => {
  if (currentUser) {
    addCurrentUserToProperties(properties, currentUser);
  }
  if (currentPage?.articleId) {
    properties.article_id = currentPage.articleId;
  }
  ahoy.start();
  ahoy.track(ahoyEventName, properties);
};

// interface User {
//   access_level: number;
//   access_level_name: string;
//   id: number;
//   subscription_plan: string;
//   subscription_status: string;
// }

/**
 * update properties with current user data
 * @param {EventProperties} properties properties to be passed to ahoy and segment
 * @param {User} currentUser current user object
 */
const addCurrentUserToProperties = (properties, currentUser) => {
  properties.user_type = currentUser.subscription_status;
  properties.subscription_plan = currentUser.subscription_plan;
  properties.access_level_id = currentUser.access_level;
  properties.access_level = currentUser.access_level_name;
  properties.user_id = currentUser.id;
};

export default trackEvent;
